module.exports = __webpack_public_path__ + "media/honey-icons/icon-multi-choice-on-e0588221.svg";